import { useRef, useState } from 'react'
import arcadeImage from '../assets/arcade.webp'
import { getYmgSdk } from '../services/sdk'
import { trackEvent } from '../services/analytics'

const LINK_BANNER_TITLE = '楽しいゲームもりだくさん！'
const LINK_BANNER_INITIAL_LIMIT = 12
const LINK_BANNER_PAGE_SIZE = 12
const LINK_BANNER_MAX_ITEMS = 100

export function ArcadeMoreButton() {
  const buttonRef = useRef<HTMLButtonElement>(null)
  const [loading, setLoading] = useState(false)

  const handleClick = async () => {
    if (loading) return

    setLoading(true)
    try {
      const sdk = await getYmgSdk()
      if (typeof sdk.showLinkBanners !== 'function') {
        throw new Error('[ArcadeMoreButton] YmgSDK.showLinkBanners is required')
      }
      await sdk.showLinkBanners({
        title: LINK_BANNER_TITLE,
        initialLimit: LINK_BANNER_INITIAL_LIMIT,
        pageSize: LINK_BANNER_PAGE_SIZE,
        maxItems: LINK_BANNER_MAX_ITEMS,
        excludeCurrentGame: true,
        sort: 'newest',
      })
      trackEvent('arcade_open', { status: 'opened' })
    } catch (err) {
      trackEvent('arcade_open', { status: 'error' })
      console.error('[ArcadeMoreButton] Failed to open SDK link banners:', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <button
      ref={buttonRef}
      type="button"
      className="ymg-arcade-more"
      onClick={handleClick}
      disabled={loading}
      aria-label={LINK_BANNER_TITLE}
    >
      <span className="ymg-arcade-more__image" aria-hidden="true">
        <img src={arcadeImage} alt="" />
      </span>
      <span className="ymg-arcade-more__label">
        楽しいゲーム
        <br />
        もりだくさん！
      </span>
    </button>
  )
}
